<template>
  <section
    class="[ flex-1 flex flex-col items-center justify-center min-h-full max-w-[450px] mx-auto ]"
  >
    <div
      class="[ flex flex-1 flex-col px-8 py-14 justify-center items-center text-black text-center ]"
    >
      <Logo :width="295" :height="63" class="[ mb-8 ]" />
      <p class="[ mb-2 ]">
        To ensure quality service, all interactions are monitored and recorded.
        Your continued use of this platform constitutes acceptance of all
        applicable laws and regulations governing its use.
      </p>
      <p class="[ mb-8 ]">Now let's get Jack to work</p>

      <router-link to="/auth/login">
        <Button>Log in</Button>
      </router-link>

      <div class="[ text-center mt-10 ]">
        <p class="[ font-bold ]">Having difficulty logging in?</p>
        <p>{{ tenantConfig.supportText || "Speak to your team leader" }}</p>
      </div>
    </div>

    <div class="[ flex items-end justify-center w-full p-4 ]">
      <div class="[ tracking-wide ]">
        &copy;{{ new Date().getFullYear() }} Jack Burton Limited
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import Logo from "@/assets/Logo.svg";
import { computed } from "vue";
import Button from "primevue/button";
import { useClientConfig } from "@/store/client-config.ts";

definePage({
  meta: {
    title: "Welcome",
    public: true,
  },
});

const clientConfig = useClientConfig();
const tenantConfig = computed(() => clientConfig.tenantGlobalConfig);
</script>
